import Hljs from 'highlight.js'
import 'highlight.js/styles/monokai-sublime.css' // monokai-sublime  tomorrow-night-bright monokai-sublime atom-one-dark
import Vue from 'vue'

const Highlight = function (el) {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    Hljs.highlightBlock(block)
  })
}

Vue.directive('highlight', Highlight)

export default {}



// WEBPACK FOOTER //
// ./src/directive/highlight.js